// extracted by mini-css-extract-plugin
export var closeButton = "_l0-1";
export var closeX = "_l0-3";
export var container = "_l0-0";
export var image = "_l0-2";